"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var styles = {
  "navigationItemIconWrapper": "Nqm6I3",
  "small": "B-XZT4"
};
var NavigationItemIcon = function NavigationItemIcon(_ref) {
  var Icon = _ref.icon,
    small = _ref.small;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])('cozy-navigation-item', styles.navigationItemIconWrapper, small && styles.small)
  }, /*#__PURE__*/_react["default"].createElement(Icon, null));
};
NavigationItemIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  icon: _propTypes["default"].elementType.isRequired,
  small: _propTypes["default"].bool
} : {};
var _default = exports["default"] = NavigationItemIcon;